import { PROCESSOR_NAMES, PROCESSORS } from '../../constants/processors';
import { FORMAT_NUMBERS, PHONECODE_US } from './../../constants';

export * from './date-ranges';

const { PHONE, EIN, SS, AMOUNT } = FORMAT_NUMBERS;

export const createReducer = (initialState, reducerMap) => {
  return (state = initialState, action) => {
    const reducer = reducerMap[action.type];
    return reducer ? reducer(state, action.payload) : state;
  };
};

export const getHostname = (href) => {
  const a = document.createElement('a');
  a.href = href;
  return a.hostname;
};

export const formatNumber = (number = '', mask = PHONE, params = {}) => {
  const commonStategy = function () {
    const cleanNumber = String(number).replace(new RegExp(/\D/, 'g'), '');
    if (!cleanNumber) return '';
    const replace = (result, symbol, index) => result.replace('X', cleanNumber[index]);
    return [...cleanNumber].reduce(replace, this.mask).replace(/[\D]*$/, '');
  };
  const amountStategy = () => {
    const opts = { maximumFractionDigits: 2, ...params };
    const num = String(number).replace(new RegExp(/[^\d.]/, 'g'), '');
    const cleanNumber = num.split('.').length > 2 ? num.replace(/\.$/, '') : num;
    return [...cleanNumber].pop() === '.'
      ? `${Number(cleanNumber).toLocaleString('us-US', opts)}.`
      : Number(cleanNumber).toLocaleString('us-US', opts);
  };

  const masks = {
    [PHONE]: {
      mask: '(XXX) XXX-XXXX',
      strategy: commonStategy
    },
    [EIN]: {
      mask: 'XX-XXXXXXX',
      strategy: commonStategy
    },
    [SS]: {
      mask: 'XXX-XX-XXXX',
      strategy: commonStategy
    },
    [AMOUNT]: {
      strategy: amountStategy
    }
  };
  return masks[mask].strategy();
};

export const validateLengthNumber = (e, n) => {
  e.target.value = e.target.value
    .replace(new RegExp(/\D/, 'g'), '')
    .substr(0, n);
};

export const validateLengthText = (e, n) => {
  e.target.value = e.target.value.substr(0, n);
};

export const swapKeyValue = target => Object
  .keys(target)
  .reduce((accum, key) => ({ ...accum, [target[key]]: key }), {});

const REVERSED_PROCESSORS = swapKeyValue(PROCESSORS);
const REVERSED_PROCESSOR_NAMES = swapKeyValue(PROCESSOR_NAMES);

export const getProcessorShorthand = processor => REVERSED_PROCESSORS[processor] || 'unknown';

export const getProcessorName = processor =>
  REVERSED_PROCESSOR_NAMES[processor] || REVERSED_PROCESSOR_NAMES[PROCESSORS[processor]] || 'unknown';

export const getAllProcessorsShorthands = () => Object.keys(PROCESSORS).reduce(
  (result, shorthand) => ({ ...result, [shorthand]: shorthand }),
  {}
);

const reg = new RegExp(`(\\${PHONECODE_US})|\\D`, 'g');
export const preparePhone = phone => phone && String(phone).replace(reg, '') || '';

let delayTimer;
export const delaySearch = (cb, params, timeout = 500) => {
  clearTimeout(delayTimer);
  delayTimer = setTimeout(() =>
      cb(params),
    timeout);
};

export const chunkArray = (array, size) => {
  if (!(array.length && size > 0)) return [];

  return [array.slice(0, size), ...chunkArray(array.slice(size), size)];
};

export const getErrorMessage = ({ message: errorMessage, data = {}, errors } = {}) => {
  const { getMessage = () => '' } = [
    {
      condition: Array.isArray(errors) && errors.length > 0,
      getMessage: () => errors.map((error = {}) => error.message || error).join(', ')
    },
    {
      condition: Array.isArray(data.errors) && data.errors.length > 0,
      getMessage: () => data.errors.map((error = {}) => error.message || error).join(', ')
    },
    {
      condition: Boolean(data.message),
      getMessage: () => data.message
    },
    {
      condition: Boolean(errorMessage),
      getMessage: () => errorMessage
    }
  ].find(({ condition }) => condition) || {};

  return getMessage();
};

export const getHashValue = () => window.location.hash.slice(1);
export const setHashValue = value => window.location.hash = value;

export const findSmallestMissing = (arr) => {
  const n = arr.length;

  if (arr[0] > 0 || !n) return 0;

  for (let i = 0; i < n; i++) {
    while (arr[i] !== i + 1) {
      if (arr[i] <= 0 || arr[i] >= n) break;

      if (arr[i] === arr[arr[i] - 1]) break;

      const temp = arr[i];
      arr[i] = arr[temp - 1];
      arr[temp - 1] = temp;
    }
  }

  for (let i = 0; i < n; i++) {
    if (arr[i] !== i + 1) {
      return i + 1;
    }
  }

  return n + 1;
};

export default {
  createReducer,
  getHostname,
  formatNumber,
  validateLengthNumber,
  swapKeyValue,
  getProcessorShorthand,
  getProcessorName,
  validateLengthText,
  getAllProcessorsShorthands,
  preparePhone,
  delaySearch,
  chunkArray,
  getErrorMessage,
  getHashValue,
  setHashValue,
  findSmallestMissing
};
